<template>
  <el-form
    label-width="auto"
    size="small"
  >
    <el-form-item
      label="Choose when the event is now due:"
      :show-message="!event.$fields.due_at.valid"
      :error="event.$fields.due_at.message"
      required
    >
      <div style="display: flex;">
        <el-date-picker
          v-model="dueDate"
          type="date"
          placeholder="Pick a due date"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          class="mr-3"
          :clearable="false"
        />
        <el-time-select
          v-model="dueTime"
          :picker-options="{
            start: '01:00',
            step: '00:15',
            end: '12:45'
          }"
          format="hh:mm"
          value-format="hh:mm"
          placeholder="Pick a due time"
          class="mr-3"
          :clearable="false"
        />
        <el-select v-model="ampm">
          <el-option
            label="AM"
            value="AM"
          />
          <el-option
            label="PM"
            value="PM"
          />
        </el-select>
      </div>
    </el-form-item>

    <el-form-item
      label="Enter a reason for deferring this event:"
      :show-message="!note.$fields.content.valid"
      :error="note.$fields.content.message"
      required
    >
      <el-input
        v-model="note.content"
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 8}"
        clearable
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      required: true
    },
    note: {
      type: Object,
      required: true
    }
  },
  computed: {
    dueDate: {
      set: function (newValue) {
        const time = this.$moment(this.event.due_at).format('HH:mm')
        this.event.due_at = this.$moment(`${newValue} ${time}`, 'YYYY-MM-DD HH:mm').toDate()
      },
      get: function () {
        return this.$moment(this.event.due_at).format('YYYY-MM-DD')
      }
    },
    dueTime: {
      set: function (newValue) {
        const date = this.$moment(this.event.due_at).format('YYYY-MM-DD')
        const ampm = this.$moment(this.event.due_at).format('A')
        this.event.due_at = this.$moment(`${date} ${newValue} ${ampm}`, 'YYYY-MM-DD hh:mm A').toDate()
      },
      get: function () {
        return this.$moment(this.event.due_at).format('hh:mm')
      }
    },
    ampm: {
      set: function (newValue) {
        const date = this.$moment(this.event.due_at).format('YYYY-MM-DD')
        const time = this.$moment(this.event.due_at).format('hh:mm')
        this.event.due_at = this.$moment(`${date} ${time} ${newValue}`, 'YYYY-MM-DD hh:mm A').toDate()
      },
      get: function () {
        return this.$moment(this.event.due_at).format('A')
      }
    }
  }
}
</script>
